<button
  mat-button
  [color]="color"
  class="button-loading {{ btnClass }}"
  [type]="type"
  [disabled]="loading"
  [ngClass]="{
    loading: loading,
    'mat-button': !raised,
    'mat-raised-button': raised
  }"
>
  @if (loading) {
  <div class="btn-spinner"></div>
  } @if (!loading) {
  <span>
    <ng-content></ng-content>
  </span>
  } @if (loading) {
  <span>{{ loadingText }}</span>
  }
</button>
